import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import CustomScrollbar, {CustomScrollbarTrackVisibility} from '../../../lib/custom-scrollbar/custom-scrollbar';
import OEIconCodes from '../../../lib/oe-icon-codes';
import retardUpdate from '../../../lib/react/update-retarder';
import OEToolbox from '../../../lib/tools/oe-toolbox';
import {OEGroupControl, OEControl, OEIconButtonGroupControl} from '../../elements/controls/oe-controls';
import OEPopover from '../../views/oe-popover';
import {OENoteAddStateControllerBtnIds, OENoteModels} from './oe-note-model';
import OEObjectModelValueEdit from '../../elements/object-model-value-edit/oe-object-model-value-edit';

export class OENoteAddStateCell extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.id = typeof(this.props.id) === 'object' ? clone(this.props.id) : null;

        this.state = this.defaultState();
        
        this.updateLanguage = this.updateLanguage.bind(this);
        this.onNoteAddStateDataChanged = this.onNoteAddStateDataChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onButtonPressed = this.onButtonPressed.bind(this);
        this.onDataChanged = this.onDataChanged.bind(this);
    }

    defaultState()  {
        return {
            uiEnabled:              false,
            data:                   null,
            strings: {
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.id !== this.props.id)     {
            this.id = typeof(nextProps.id) === 'object' ? clone(nextProps.id) : null;
            this.updateAddStateData();
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteAddStateDataChanged, this.onNoteAddStateDataChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteAddStateDataChanged, this.onNoteAddStateDataChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);	
    }

    updateLanguage()   {
        if(!this.oe.isReady())  return;
    }

    updateAddStateData()  {
        if((!this.oe.isReady() || this.id === null))    return;

        let data = this.oe.sharedInterface.getUIControllerNote().getNoteAddStateDataID(this.id.note, this.id.addState);

        this.setState({
            data: {
                userRef: data.userRef,
                differ: data.differ
            }
        });
    }

    updateUIState()    {
        if(!this.oe.isReady())  return;

        this.setState({
            uiEnabled:          this.oe.sharedInterface.getUIControllerNote().getUIEnabled()
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released)   {
            this.setState(this.defaultState());
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
            this.updateUIState();
            this.updateAddStateData();
        });
    }

    onNoteAddStateDataChanged(message, userInfo)   {
        if(!OEToolbox.shallowEqual(this.id, {note: userInfo.ID, addState: userInfo.addStateID}))  return;
        this.updateAddStateData();
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.note) {
            this.updateUIState();
        }
    }

    render()    {
        let disabled = !this.state.uiEnabled;

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                
                <div className={'note-add-state-cell ' + this.props.className}>

                    <OEGroupControl>
                        <OEIconButtonGroupControl
                            title={this.state.strings.imageBtnGroupLabel}
                            buttons={[
                                {
                                    id: OENoteAddStateControllerBtnIds.dumpAddState,
                                    icon: OEIconCodes.noteAddStateDump,
                                    disabled: disabled
                                },
                                {
                                    id: OENoteAddStateControllerBtnIds.setAddState,
                                    icon: OEIconCodes.noteAddStateSet,
                                    disabled: disabled || !this.state.data.differ
                                },
                                {
                                    id: OENoteAddStateControllerBtnIds.applyAddState,
                                    icon: OEIconCodes.noteAddStateApply,
                                    disabled: disabled || !this.state.data.differ,
                                    iconClassName: 'rotate-180'
                                }
                            ]}
                            onPressed={this.onButtonPressed}
                        />

                        <OEControl>
                            <OEObjectModelValueEdit
                                className="multi-column"
                                disabled={disabled}
                                model={OENoteModels.addStateData}
                                object={this.state.data}
                                onChange={this.onDataChanged}
                            />
                        </OEControl>
                    </OEGroupControl>

                </div>
            </React.Fragment>
        );
    }

    onButtonPressed(sender, id) {
        if(!this.oe.isReady() || this.id === null) return;

        if(id === OENoteAddStateControllerBtnIds.dumpAddState)    {
            this.oe.sharedInterface.getUIControllerNote().removeNoteAddStateID(this.id.note, this.id.addState);
        } else if(id === OENoteAddStateControllerBtnIds.setAddState)    {
            this.oe.sharedInterface.getUIControllerNote().setNoteAddStateID(this.id.note, this.id.addState);
        } else if(id === OENoteAddStateControllerBtnIds.applyAddState)    {
            this.oe.sharedInterface.getUIControllerNote().applyNoteAddStateID(this.id.note, this.id.addState);
        }
    }

    onDataChanged(sender, params)    {
        if(!this.oe.isReady() || this.id === null) return;
        let controller = this.oe.sharedInterface.getUIControllerNote();

        controller.setNoteAddStateUserRefID(this.id.note, this.id.addState, params.userRef);
    }
};

OENoteAddStateCell.defaultProps = {
    moduleId:               '',
    className:              ''
};

OENoteAddStateCell.propTypes = {
    moduleId:               PropTypes.string,
    className:              PropTypes.string,
    id:     PropTypes.shape({
        note:               PropTypes.number,
        addState:           PropTypes.number
    })
}; 

//
export class OENoteAddStateController extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.id = typeof(this.props.id) === 'number' ? this.props.id : null;

        this.style = null;

        this.state = this.defaultState();
        
        this.updateLanguage = this.updateLanguage.bind(this);
        this.onNoteAddStateAdded = this.onNoteAddStateAdded.bind(this);
        this.onNoteAddStateRemoved = this.onNoteAddStateRemoved.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onButtonPressed = this.onButtonPressed.bind(this);
    }

    defaultState()  {
        return {
            uiEnabled:              false,
            addStateIds:            [],
            strings: {
                groupLabel:         '',
                btnGroupLabel:      ''
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.id !== this.props.id)     {
            this.id = typeof(nextProps.id) === 'number' ? clone(nextProps.id) : null;
            this.updateAddStateIds();
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteAddStateAdded, this.onNoteAddStateAdded);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteAddStateRemoved, this.onNoteAddStateRemoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteAddStateAdded, this.onNoteAddStateAdded);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteAddStateRemoved, this.onNoteAddStateRemoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);	
    }

    updateLanguage()   {
        if(!this.oe.isReady())  return;

        this.setState({
            strings: {
                groupLabel:         this.oe.sharedInterface.getLocalizedStringEnc('note_add_state_view_group'),
                //btnGroupLabel:    this.oe.sharedInterface.getLocalizedStringEnc('note_add_state_view_btn_group'),
            }
        });
    }

    updateAddStateIds()  {
        if((!this.oe.isReady() || this.id === null))    {
            this.setState({addStateIds: []});
            return;
        }

        let ids = this.oe.sharedInterface.getUIControllerNote().getNoteAddStateIDs(this.id);
        ids = ids.map((id) => { return {note: this.id, addState: id}; });
        this.setState({addStateIds: ids});
    }

    updateUIState()    {
        if(!this.oe.isReady())  return;

        this.setState({
            uiEnabled:          this.oe.sharedInterface.getUIControllerNote().getUIEnabled()
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released)   {
            this.setState(this.defaultState());
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
            this.updateUIState();
            this.updateAddStateIds();
        });
    }

    onNoteAddStateAdded(message, userInfo)   {
        if(userInfo.ID !== this.id)  return;
        this.updateAddStateIds();
    }

    onNoteAddStateRemoved(message, userInfo) {
        if(userInfo.ID !== this.id)  return;
        this.updateAddStateIds();
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.note) {
            this.updateUIState();
        }
    }

    render()    {
        let disabled = !this.state.uiEnabled;

        const cells = this.state.addStateIds.map(id =>
            <OENoteAddStateCell key={id.addState} moduleId={this.props.moduleId} id={id}/>
        );

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                
                <div className={'note-add-state-controller ' + this.props.className}>

                    <OEGroupControl title={this.state.strings.groupLabel}>

                        <OEIconButtonGroupControl
                            title={this.state.strings.btnGroupLabel}
                            disabled={disabled}
                            buttons={[
                                {
                                    id: OENoteAddStateControllerBtnIds.newAddState,
                                    icon: OEIconCodes.noteAddStateNew
                                }
                            ]}
                            onPressed={this.onButtonPressed}
                        />

                    </OEGroupControl>

                    <CustomScrollbar
                        className="note-add-state-container"
                        horizontalTrackVisiblity={CustomScrollbarTrackVisibility.none}
                        verticalTrackVisiblity={CustomScrollbarTrackVisibility.always}
                    >
                        {cells}
                    </CustomScrollbar>

                </div>
            </React.Fragment>
        );
    }

    onButtonPressed(sender, id) {
        if(!this.oe.isReady() || this.id === null) return;

        if(id === OENoteAddStateControllerBtnIds.newAddState)    {
            this.oe.sharedInterface.getUIControllerNote().addNoteAddState(this.id);
        }
    }
}

OENoteAddStateController.defaultProps = {
    moduleId:               '',
    className:              ''
};

OENoteAddStateController.propTypes = {
    moduleId:               PropTypes.string,
    className:              PropTypes.string,
    id:                     PropTypes.number
}; 

//
export const OENoteAddStatePopoverController = OEPopover.coat(OENoteAddStateController, {
    noHeader:               true,
}, {
    placement:              'right',
    buttonClassName:        'transparent-btn',
    controllerClassName:    'note-add-state-popover compact'
}, {
    controllerClassName:    PropTypes.string
});